const whenLivewireReady = (callback) => {
    if (typeof window === 'undefined') {
        return;
    }

    const invoke = () => {
        if (!window.Livewire) {
            return false;
        }

        callback(window.Livewire);

        return true;
    };

    if (invoke()) {
        return;
    }

    document.addEventListener('livewire:load', () => {
        invoke();
    }, { once: true });
};

export const onLivewireCommit = (callback) => {
    whenLivewireReady((livewire) => {
        livewire.hook('commit', ({ component, commit, respond, succeed, fail }) => {
            callback({ component, commit, respond, succeed, fail });
        });
    });
};

export const onLivewireProcessed = (callback) => {
    onLivewireCommit(({ component, succeed }) => {
        succeed(() => {
            callback({ component });
        });
    });
};

export const onLivewireCommitLifecycle = ({ start, finish }) => {
    onLivewireCommit(({ component, succeed, fail }) => {
        start?.({ component });

        const finalize = () => {
            finish?.({ component });
        };

        succeed(() => {
            finalize();
        });

        fail(() => {
            finalize();
        });
    });
};

export const onLivewirePageExpired = (callback) => {
    whenLivewireReady((livewire) => {
        livewire.hook('request', ({ fail }) => {
            fail(({ status, response, content, preventDefault }) => {
                if (status !== 419) {
                    return;
                }

                preventDefault();
                callback({ status, response, content });
            });
        });
    });
};
